const popupWrapper = document.querySelector('.cart-popup-wrapper');
const closePopupBtn = document.querySelector('.cart-popup-close');
const popupContainer = document.querySelector('.cart-popup-container');
const popupContent = popupContainer.querySelector('.cart-popup-content'); 
const popupImage = popupContainer.querySelector('.cart-popup-image');

const openPopup = (dataInfo, img) => {
  if (popupContent) {
    popupContent.innerHTML = dataInfo || '<p>Немає інформації про продукт.</p>';
    if (img) {
      const clonedImage = img.cloneNode(true); // Створюємо копію зображення
      popupImage.innerHTML = ''; // Очищаємо контейнер для зображення
      popupImage.appendChild(clonedImage); // Додаємо копію зображення в модалку
    }
  }

  popupWrapper.classList.remove('cart-popup-disabled');
  document.body.style.overflowY = 'hidden';

  const drawerCloseIcon = document.querySelector(".cart-drawer .drawer__close-icon");
  if (drawerCloseIcon) {
    drawerCloseIcon.click();
  }
};

const closePopup = () => {
  popupWrapper.classList.add('cart-popup-disabled');
  document.body.style.overflowY = '';
  if (popupContent) {
    popupContent.innerHTML = ''; 
  }
  if (popupImage) {
    popupImage.innerHTML = ''; 
  }
};

// Слухач кліків на продукт
document.addEventListener('click', (e) => {
  const productWrapper = e.target.closest('.qsc2-r-product-wrapper');
  if (productWrapper) {
    const dataInfo = productWrapper.getAttribute('data-info'); 
    const productImage = productWrapper.querySelector('.qsc2-r-product__image img');
    if (dataInfo) {
      openPopup(dataInfo, productImage);
    }
  }
});

closePopupBtn.addEventListener('click', closePopup);

popupWrapper.addEventListener('click', (event) => {
  if (!popupContainer.contains(event.target)) {
    closePopup();
  }
});
